import React, { useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useOutsideClickHandler } from '../../useDetectClickOut';

import './modal.css';

export default function RemoveModal({
	text,
	title,
	setModalOpen,
	setAction,
	visible
}: {
	text: string;
	title: string;
	setModalOpen: (isOpen: boolean) => void;
	setAction: () => void;
	visible: boolean;
}) {
	const wrapperRef = useRef(null) as any;

	useEffect(() => {
		function handleClickOutside(event: any) {
			if (wrapperRef.current && !wrapperRef.current.contains(event.target))
				setModalOpen(false);
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [wrapperRef]);

	return (
		<CSSTransition in={visible} timeout={400} unmountOnExit classNames="modal">
			{(state) => (
				<div
					id="defaultModal"
					aria-hidden="true"
					className="overflow-y-auto overflow-x-hidden backdrop-blur-md fixed z-30
							  w-full inset-0 h-modal h-full"
				>
					<div className="absolute inset-0 w h-full w-full opacity-50 bg-black" />
					<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ml-8 px-4 py-2 w-fit max-w-sm h-full md:h-auto">
						<div
							className="relative bg-gray-300 rounded-lg shadow-lg dark:bg-gray-900 transition-colors duration-300 "
							ref={wrapperRef}
						>
							<div className="flex justify-between items-start px-4 py-2">
								<h3 className="text-xl text-center font-semibold text-gray-900 dark:text-white">
									{title}
								</h3>
								<button
									type="button"
									className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
									data-modal-toggle="defaultModal"
									onClick={(e) => {
										e.stopPropagation();
										setModalOpen(false);
									}}
								>
									<svg
										className="w-5 h-5"
										fill="currentColor"
										viewBox="0 0 20 20"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
											clip-rule="evenodd"
										></path>
									</svg>
								</button>
							</div>
							<div className="px-4 py-2 space-y-4 border-t border-gray-500">
								<h3 className="text-left text-gray-700 dark:text-gray-400">
									{text}
								</h3>
							</div>
							<div className="flex items-center px-4 pt-1 pb-4 space-x-2 rounded-b">
								<button
									data-modal-toggle="defaultModal"
									type="button"
									className="btn btn-outline btn-sm btn-error mr-1"
									style={{ transition: 'all .15s ease' }}
									onClick={(e) => {
										e.stopPropagation();
										setAction();
									}}
								>
									Remove
								</button>

								<button
									data-modal-toggle="defaultModal"
									className="btn btn-outline btn-sm mr-1 "
									type="button"
									style={{ transition: 'all .15s ease' }}
									onClick={(e) => {
										e.stopPropagation();
										setModalOpen(false);
									}}
								>
									Cancel
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</CSSTransition>
	);
}
